export default __webpack_public_path__ + "static/media/people.42fd0c5d.png";